const { registerBlockType } = wp.blocks;
const { TextControl, PanelBody, Button, SelectControl } = wp.components;
const { InspectorControls } = wp.editor;
const { useState, useEffect } = wp.element;

registerBlockType('ellis-marsalis/in-the-news', {
    title: 'In the News Pull',
    description: 'Customizable pull from the In the News post type',
    category: 'ellis-marsalis', // Custom category
    icon: 'megaphone',
    keywords: [
        'news',
        'in the news',
        'articles',
        'news',
        'in the news pull'
    ],
    attributes: {
        how_many: {
            type: 'integer',
            default: 3, // Default number of in the news to show
        },
    },
    edit: function (props) {
        const { attributes, setAttributes } = props;
        const { how_many } = attributes;
        const [inTheNews, setInTheNews] = useState([]);

        // Function to fetch people for the selected group
        const fetchNewsItems = async (how_many) => {
            try {
                const per_page = parseInt(how_many, 10); // Parse as integer
                const response = await fetch(`/wp-json/wp/v2/in-the-news?per_page=${per_page}`);
                const data = await response.json();
                return data;
            } catch (error) {
                console.error('Error fetching news items:', error);
            }
        };

        // Function to strip HTML tags from content
        const stripHtml = (html) => {
            let doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.body.childNodes).map(node => node.textContent).join(' ');
        }


        const createExcerpt = (str, wordCount) => {
            return str.split(" ", wordCount).join(" ") + "...";
        }

        useEffect(() => {
            fetchNewsItems(how_many)
                .then(data => {
                    setInTheNews(data);

                    // Do something with the fetched data
                });
        }, [how_many]);

        return (
            <>
                <InspectorControls>
                    <PanelBody title="In the News Settings">
                        <TextControl
                            label="Number of News Items"
                            value={how_many.toString()}  // Convert to string for display
                            onChange={(newHowMany) => {
                                const num = parseInt(newHowMany, 10) || 0;  // Parse as integer
                                setAttributes({ how_many: num });
                            }}
                        />
                    </PanelBody>
                </InspectorControls>
                <div className="in-the-news-grid">
                    {inTheNews.map((newsItem) => (
                        <div className="in-the-news-item">
                            <div className="newsItem-details">
                                <h5 className="newsItem-title" style={{ marginBottom: '-4px' }}><a href={newsItem.link}>{newsItem.title.rendered}</a></h5>
                                <p>{newsItem.content ? createExcerpt(stripHtml(newsItem.content.rendered), 50) : 'No content available.'}</p>
                                <a className="button" href={newsItem.link}>Read More</a>  {/* Assuming `link` is available in your data */}
                            </div>                        </div>
                    ))}
                </div>
            </>
        );
    },
    save: function (props) {
        const { how_many } = props.attributes;

        // Just save the how_many value as a data attribute
        return (
            <div className="in-the-news-grid" data-how_many={how_many}></div>
        );
    },
});